import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {

  @Input() sectionIndex : number;
  @Input() textKey: string;
  @Input() percentageInSection : number;
  @Input() pictures : string[];

  constructor() { }

  ngOnInit() {
  }

}
